import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { MiscService } from "app/shared/services/misc.service";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { AuthService } from "../_services/auth.service";
import * as authActions from "./auth.actions";

@Injectable({
    providedIn: 'root'
})

export class AuthEffects {

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private storageManager: AppLocalStorage,
    private toastr: ToastrService,
    private miscService: MiscService,
    private router: Router
  ) {}

    // login$ = createEffect(() => this.actions$.pipe(
    //     ofType(authActions.login),
    //     exhaustMap((action) => this.authService.login(action.credentials).pipe(
    //         tap((response: LoginSucessResponseInterface) => {
    //             localStorage.setItem('xs_access_token', response.data.token);
    //             localStorage.setItem('session_id', response.data.session_id);
    //             this.storageManager.storeToStorage('user', response.data.data);
    //             this.miscService.updateUser(response.data.data)
    //             this.router.navigate(['/app/dashboard/successful-bulkPay']);
    //         }),
    //         exhaustMap(() => [
    //             authActions.loginSuccessful()
    //         ]),
    //         catchError((error: HttpErrorResponse) => {
    //             this.toastr.error(error?.error?.errors || 'Network error');
    //             return of(authActions.loginFailed({ message: error?.error?.errors, code: error.status }))
    //         })
    //     ))
    // ));

    logout$ = createEffect(() => this.actions$.pipe(
        ofType(authActions.logout),
        tap(() => {
            localStorage.clear()
            this.router.navigate(['/auth']);
        }),
        exhaustMap(() => [])
    ));

}